module.exports = __webpack_public_path__ + "img/icon3.328854d.png";